import { createLogo, createLogoAlt } from "./iconCore"
import AppleSvg from "./logos/apple.svg"
import AppleAltSvg from "./logos/appleAlt.svg"
import CollabsSvg from "./logos/collabs.svg"
import DiscordSvg from "./logos/discord.svg"
import DiscordAltSvg from "./logos/discordAlt.svg"
import FacebookSvg from "./logos/facebook.svg"
import FacebookAltSvg from "./logos/facebookAlt.svg"
import GiphySvg from "./logos/giphy.svg"
import GoogleSvg from "./logos/google.svg"
import InstagramSvg from "./logos/instagram.svg"
import LinkedInSvg from "./logos/linkedin.svg"
import RtmpSvg from "./logos/rtmp.svg"
import RtmpAltSvg from "./logos/rtmpAlt.svg"
import ShopAppSvg from "./logos/shopApp.svg"
import ShopAppAltSvg from "./logos/shopAppAlt.svg"
import ShopifySvg from "./logos/shopify.svg"
import ShopifyAltSvg from "./logos/shopifyAlt.svg"
import StageTenSvg from "./logos/stageTen.svg"
import StageTenAltSvg from "./logos/stageTenAlt.svg"
import TargetSvg from "./logos/target.svg"
import TargetAltSvg from "./logos/targetAlt.svg"
import ThreadsSvg from "./logos/threads.svg"
import ThreadsAltSvg from "./logos/threadsAlt.svg"
import TiktokSvg from "./logos/tiktok.svg"
import TiktokAltSvg from "./logos/tiktokAlt.svg"
import TwitchSvg from "./logos/twitch.svg"
import TwitchAltSvg from "./logos/twitchAlt.svg"
import TwitterSvg from "./logos/twitter.svg"
import TwitterAltSvg from "./logos/twitterAlt.svg"
import XSvg from "./logos/x.svg"
import XAltSvg from "./logos/xAlt.svg"
import YoutubeSvg from "./logos/youtube.svg"
import YoutubeAltSvg from "./logos/youtubeAlt.svg"

export const Apple = createLogo(AppleSvg, "Apple")

export const AppleAlt = createLogoAlt(AppleAltSvg, "Apple")

export const Collabs = createLogo(CollabsSvg, "Collabs")

export const Discord = createLogo(DiscordSvg, "Discord")

export const DiscordAlt = createLogoAlt(DiscordAltSvg, "Discord")

export const Facebook = createLogo(FacebookSvg, "Facebook")

export const FacebookAlt = createLogoAlt(FacebookAltSvg, "Facebook")

export const Instagram = createLogo(InstagramSvg, "Instagram")

export const Giphy = createLogo(GiphySvg, "Giphy")

export const Google = createLogo(GoogleSvg, "Google")

export const LinkedIn = createLogo(LinkedInSvg, "LinkedIn")

export const Rtmp = createLogo(RtmpSvg, "RTMP")

export const RtmpAlt = createLogoAlt(RtmpAltSvg, "RTMP")

export const ShopApp = createLogo(ShopAppSvg, "ShopApp")

export const ShopAppAlt = createLogoAlt(ShopAppAltSvg, "ShopApp")

export const Shopify = createLogo(ShopifySvg, "Shopify")

export const ShopifyAlt = createLogo(ShopifyAltSvg, "Shopify")

export const StageTen = createLogo(StageTenSvg, "StageTen")

export const StageTenAlt = createLogoAlt(StageTenAltSvg, "StageTen")

export const Target = createLogo(TargetSvg, "Target")

export const TargetAlt = createLogoAlt(TargetAltSvg, "Target")

export const Threads = createLogo(ThreadsSvg, "Threads")

export const ThreadsAlt = createLogoAlt(ThreadsAltSvg, "Threads")

export const Tiktok = createLogo(TiktokSvg, "Tiktok")

export const TiktokAlt = createLogoAlt(TiktokAltSvg, "Tiktok")

export const Twitch = createLogo(TwitchSvg, "Twitch")

export const TwitchAlt = createLogoAlt(TwitchAltSvg, "Twitch")

export const Twitter = createLogo(TwitterSvg, "Twitter")

export const TwitterAlt = createLogoAlt(TwitterAltSvg, "Twitter")

export const X = createLogo(XSvg, "X")

export const XAlt = createLogoAlt(XAltSvg, "X")

export const Youtube = createLogo(YoutubeSvg, "Youtube")

export const YoutubeAlt = createLogoAlt(YoutubeAltSvg, "Youtube")
